import * as React from "react";
import {Box, Button, Stack, Typography, Container} from "@mui/material";
import {styled} from "@mui/material/styles";
import {useParams, useNavigate} from "react-router-dom";

const Img = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    width: '320px',
    height: '191px',
    borderRadius: '5px'
});

const AdviceRelateCard = ({name, categoryId}) => {
    const {id} = useParams();
    const nav = useNavigate();

    return (
        <Box>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={4}
            >
                <Typography variant={'h4'} sx={{color:'#26383E'}}>
                    {name}
                </Typography>
                <Img
                    alt={'Conseil associé'}
                    src={`/assets/img/advice4.png`}
                    role="img"
                />
                <Box className={"advice-button"} onClick={ () => nav(`/advice/${id}/${categoryId}`)} sx={{cursor:'pointer'}}>
                    <Typography variant={"body2"} sx={{color:'#007FAA'}}>Découvrir</Typography>
                </Box>
            </Stack>
        </Box>
    )
}

export default AdviceRelateCard;
